import topicoAjudaService from "@/service/topicoAjudaService";
import { usePagination } from "@/composables/usePagination";
import { ref } from "vue";

export function useTopicos() {
  const topicos = ref([]);
  const isLoading = ref(false);
  const isSaving = ref(false);

  const pagination = usePagination({
    initialPage: 1,
    pageSize: 10,
    baseIndex: 1,
  });

  const fetchAllTopicos = async () => {
    isLoading.value = true;
    try {
      const response = await topicoAjudaService.getAllTopicoAjuda();
      topicos.value = response || [];
    } catch (error) {
      console.error("Error fetching topicos:", error);
    } finally {
      isLoading.value = false;
    }
  };

  const fetchTopicosByPage = async (page = pagination.currentPage.value) => {
    isLoading.value = true;
    try {
      const response = await topicoAjudaService.getTopicoAjudaPaginado(
        page,
        pagination.pageSize.value
      );
      topicos.value = response?.data || response || [];
      pagination.setPaginationInfo(response);
      pagination.currentPage.value = page;
    } catch (error) {
      console.error("Error fetching topicos by page:", error);
    } finally {
      isLoading.value = false;
    }
  };

  const saveTopico = async (topico) => {
    isSaving.value = true;
    try {
      await topicoAjudaService.createTopicoAjuda(topico);
      await fetchAllTopicos();
    } catch (error) {
      console.error("Error saving topico:", error);
    } finally {
      isSaving.value = false;
    }
  };

  const updateTopico = async (id, topico) => {
    isSaving.value = true;
    try {
      await topicoAjudaService.updateTopicoAjuda(id, topico);
      await fetchAllTopicos();
    } catch (error) {
      console.error("Error updating topico:", error);
    } finally {
      isSaving.value = false;
    }
  };

  const deleteTopico = async (id) => {
    isLoading.value = true;
    try {
      await topicoAjudaService.deleteTopicoAjuda(id);
      await fetchAllTopicos();
    } catch (error) {
      console.error("Error deleting topico:", error);
    } finally {
      isLoading.value = false;
    }
  };

  const nextPage = () => pagination.nextPage(fetchTopicosByPage);
  const previousPage = () => pagination.previousPage(fetchTopicosByPage);
  const goToPage = (page) => pagination.goToPage(page, fetchTopicosByPage);

  return {
    topicos,
    isLoadingTopico: isLoading,
    isSavingTopico: isSaving,
    totalTopicos: pagination.totalElements,
    currentPage: pagination.currentPage,
    totalPages: pagination.totalPages,
    pageSize: pagination.pageSize,
    hasNextPage: pagination.hasNextPage,
    hasPreviousPage: pagination.hasPreviousPage,
    fetchAllTopicos,
    fetchTopicosByPage,
    saveTopico,
    updateTopico,
    deleteTopico,
    nextPage,
    previousPage,
    goToPage,
  };
}
